<script>
import MaccordionItemAlgoServer from "./MaccordionItemAlgoServer.vue";

export default {
  name: "MaccordionAlgoServer",
  components: { MaccordionItemAlgoServer },
  props: {
    content: Array,
    dataItem: Object,
  },
  methods: {
    changeTrigger(param) {
      this.$emit("changeTriggered", param);
    },
  },
};
</script>
<template>
  <div class="accordion box" role="presentation">
    <Maccordion-item-algo-server
      v-for="item in content"
      :item="item"
      :key="item.id"
      :dataItem="dataItem"
      @changeTriggered="changeTrigger($event)"
    >
    </Maccordion-item-algo-server>
  </div>
</template>
